var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-row gap-4 justify-between md:justify-start text-r-green-5"},_vm._l((_vm.range),function(val){return _c('div',{key:val,staticClass:"text-4xl cursor-pointer",on:{"click":function($event){return _vm.$emit('input', val)}}},[_c('font-awesome-icon',{staticClass:"transition-all duration-150",class:[
                    val <= _vm.stars ? 'text-r-gold' : 'text-r-gray opacity-50',
                ],attrs:{"icon":"star"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }